import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";
import { Link } from 'react-router-dom';
import PageMeta from '@/components/SEO/PageMeta';

const ThankYou = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <PageMeta 
        title="Merci - Confirmation Bilan Patrimonial | La Patrimoniale"
        description="Votre demande de bilan patrimonial La Patrimoniale a bien été enregistrée. Nos conseillers vous contacteront sous 48h pour analyser ensemble votre patrimoine et vous proposer des solutions personnalisées en gestion de patrimoine, investissement et optimisation fiscale. Merci pour votre confiance en La Patrimoniale, expert patrimonial à Paris."
        keywords="La Patrimoniale, confirmation bilan patrimonial, prise de contact La Patrimoniale, rendez-vous gestion patrimoine, expert patrimonial Paris, services La Patrimoniale, suivi client La Patrimoniale, cabinet gestion patrimoine, patrimoine Paris"
        canonical="https://www.la-patrimoniale-gestion.com/merci"
        noIndex={true}
      />
      <Navbar />
      <main className="flex-grow pt-20 pb-16 bg-gray-50 flex items-center justify-center">
        <div className="container mx-auto px-6 max-w-3xl text-center">
          <div className="bg-white rounded-lg shadow-lg p-10 border border-patrimoine-gold/20">
            <div className="flex justify-center mb-6">
              <div className="rounded-full bg-green-100 p-4">
                <CheckCircle className="h-16 w-16 text-green-500" />
              </div>
            </div>
            
            <h1 className="text-3xl font-bold mb-4 text-patrimoine-dark">Merci pour votre demande !</h1>
            
            <p className="text-lg mb-8 text-gray-700">
              Votre demande de bilan patrimonial a bien été reçue. 
              Nos conseillers vont étudier votre situation et vous contacteront 
              sous 48 heures pour planifier un rendez-vous personnalisé.
            </p>
            
            <div className="bg-gray-50 p-6 rounded-md mb-8 border border-gray-100">
              <h2 className="text-xl font-semibold mb-3 text-patrimoine-DEFAULT">Prochaines étapes</h2>
              <ol className="text-left space-y-3 list-decimal list-inside">
                <li className="text-gray-700">Analyse préliminaire de votre situation</li>
                <li className="text-gray-700">Contact téléphonique pour préciser vos besoins</li>
                <li className="text-gray-700">Rendez-vous pour présentation de solutions personnalisées</li>
                <li className="text-gray-700">Accompagnement dans la mise en place de vos projets</li>
              </ol>
            </div>
            
            <div className="flex flex-col md:flex-row justify-center gap-4">
              <Link to="/">
                <Button variant="outline" size="lg">
                  Retour à l'accueil
                </Button>
              </Link>
              <Link to="/services">
                <Button className="bg-patrimoine-DEFAULT hover:bg-patrimoine-dark text-white" size="lg">
                  Découvrir nos services
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ThankYou;
